export enum FarmerReprocessingSource {
  AccountChange = 'account-change',
  BookingResync = 'booking-resync',
  Import = 'import',
  IntegrationSync = 'integration-sync',
  Manual = 'manual',
  Promotion = 'promotion',
  /** Queued by undoing a process, so a recompute caused by a revert is not read as a fresh run. */
  Revert = 'revert',
  SnapshotRestore = 'snapshot-restore',
  TierOverride = 'tier-override',
}
